import { useEffect, useMemo, useState } from "react"
import classNames from "classnames"

import { ApiTypes } from "types"

import useUrlQueryParams from "hooks/useUrlQueryParams"

import { PaginationDropdown } from "../PaginationDropdown"
import PaginationItems from "./PaginationItems"

import styles from "./index.module.scss"

interface Props {
  meta?: ApiTypes.Model.Pagination
  paddingNone?: boolean
}

export const Pagination = ({ meta, paddingNone }: Props) => {
  const { setUrlQueryParams, urlQueryParams } = useUrlQueryParams()

  const getPerPage = () => {
    const perPage = urlQueryParams["perPage"] || 15
    return typeof perPage === "string" ? parseInt(perPage) : perPage
  }

  const [data, setData] = useState({
    currentPage: 0,
    from: 0,
    lastPage: 0,
    total: 0,
    perPage: getPerPage(),
  })

  const onPageChange = (value: number) => {
    setUrlQueryParams({ page: value })
    setData(prevStats => ({
      ...prevStats,
      page: value,
    }))
  }

  const onPerPageChange = (value: number) => {
    setData(prevStats => ({
      ...prevStats,
      perPage: value,
    }))

    if (data.perPage < value) {
      setData(prevStats => ({
        ...prevStats,
        page: 1,
      }))

      setUrlQueryParams({
        perPage: value,
        page: 1,
      })
    } else {
      setUrlQueryParams({
        perPage: value,
      })
    }
  }

  useEffect(() => {
    if (!meta) return

    const { current_page, from, last_page, per_page, total } = meta

    setData({
      currentPage: current_page,
      lastPage: last_page,
      perPage: per_page,
      total: total,
      from,
    })

    if (current_page > last_page) {
      onPageChange(last_page)
    }
  }, [meta])

  const pagesCount = useMemo(() => {
    if (data.total === 0) {
      return 1
    }

    return Math.ceil(data.total / data.perPage)
  }, [data])

  const currentPage = data.total === 0 ? 1 : data.currentPage

  return (
    <div className={classNames(styles.paginationWrapper, { [styles.paddingNone]: paddingNone })}>
      <div className={styles.paginationText}>
        Page {currentPage} of {pagesCount}
      </div>
      <PaginationItems currentPage={currentPage} totalPages={pagesCount} onPageChange={onPageChange} />
      <PaginationDropdown onSelect={onPerPageChange} currentNumber={data.perPage} numbersOfPage={[50, 30, 15, 5]} />
    </div>
  )
}
